(ns teamoesterreich.admin-mode.training.training-detail-form
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]

            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.ui-helper.email-block-edit-card :as edit-email-card]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.data.training :as d-trainings]

            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.markdown :refer [md]]))




(defn get-base [!actual-training disabled]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !data (r/cursor !st [:data])
        !orgId (r/cursor !st [:data :trainingEvent-orgId])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       (log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!actual-training key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!actual-training key))))
            has-changes? (or
                           (changed? :trainingEvent-name)
                           (changed? :trainingEvent-locationName)
                           (changed? :trainingEvent-acceptableUntil)
                           (changed? :trainingEvent-timeFrom)
                           (changed? :trainingEvent-timeTo)
                           (changed? :trainingEvent-orgId)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            ]

        (when (nil? @!orgId) (reset! !orgId (:trainingEvent-orgId @!actual-training)))

        [mui/card
         (log/debug "rerender form " @!data)
         [mui/card-header {:title "Veranstaltung Details"}]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "0"}
            }


           [mui/grid
            {:item  true
             :md    6
             :xs    11
             :style {:backgroundColor (if (changed? :crowdtaskerEvent-orgId) "#ffd6d2" "#ffffff")}
             }
            [(org-selector/get-org-selector !orgId (d-rights/get-rights-orgId-filter d-rights/TRAINING) {:longRow 1 :border "" :readonly (not @!edit-mode)})]
            ]
           [mui/grid
            {:item  true
             :md    6
             :xs    1
             :style {:backgroundColor (if (changed? :crowdtaskerEvent-orgId) "#ffd6d2" "#ffffff")}
             } ""]

           [mui/grid
            {:container false :item true
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :trainingEvent-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:trainingEvent-name @!actual-training))
                             :onChange     (fn [e] (change-fn :trainingEvent-name (h/event-value e)))
                             :label        "Veranstaltung Name"}]
            ]
           [mui/grid
            {:container false :item true
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :trainingEvent-locationName) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:trainingEvent-locationName @!actual-training))
                             :onChange     (fn [e] (change-fn :trainingEvent-locationName (h/event-value e)))
                             :label        "Veranstaltung Ort"}]
            ]


           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }

            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :trainingEvent-acceptableUntil) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Anmelde Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :trainingEvent-acceptableUntil date)))
                             ;:error (< u-birthday 0)
                             :defaultValue    (h/from-timezone-iso (:trainingEvent-acceptableUntil @!actual-training))
                             ;:helperText (if (< u-birthday 0) "Geburtsdatum ist ein Pflichtfeld" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :trainingEvent-timeFrom) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Beginn"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :trainingEvent-timeFrom date)))
                             ;:error (< u-birthday 0)
                             :defaultValue    (h/from-timezone-iso (:trainingEvent-timeFrom @!actual-training))
                             ;:helperText (if (< u-birthday 0) "Geburtsdatum ist ein Pflichtfeld" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :trainingEvent-timeTo) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :trainingEvent-timeTo date)))
                             ;:error (< u-birthday 0)
                             :defaultValue    (h/from-timezone-iso (:trainingEvent-timeTo @!actual-training))
                             ;:helperText (if (< u-birthday 0) "Geburtsdatum ist ein Pflichtfeld" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          :onClick   #(reset! !edit-mode false)
                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (not has-changes?)
                          :onClick   (fn []
                                       (d-trainings/>training-save (:trainingEvent-uuid @!actual-training) @!data
                                                                   (fn [data] (reset! !actual-training data))))
                          } "Speichern"])

           ]
          ]

         ]))))


(defn get-description [!actual-training disabled]
  (let [!state (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !show-send-me (r/cursor !state [:show-send-me])]
    (fn []
      (let [has-edit-right false
            save-fn (fn [text]
                      (d-trainings/>training-save (:trainingEvent-uuid @!actual-training) {:trainingEvent-description text}
                                                  (fn [data]
                                                    (reset! !actual-training data))))]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du diese Veranstaltungs-Beschreibung Email testweise an dich senden ?" "Senden"
          (fn [] (d-trainings/>training-send-test-briefing (:trainingEvent-uuid @!actual-training) (:tom-id @!actual-user)))]
         (if disabled
           [:div
            [:h3 "Veranstaltungs-Beschreibung (Anmeldeseite, #BRIEFING#)"]
            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-training :trainingEvent-description) ""))}
                   :className               "editor-preview-widget"
                   :style                   {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]]
           [(edit-md-card/get-it (get @!actual-training :trainingEvent-description) save-fn (str backend/BASE_URL "/media-upload")
                                 {:title          "Veranstaltungs-Beschreibung"
                                  :template-group "training"
                                  :subText        "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#,#BOOKING_LINK#"}
                                 [mui/button {
                                              :variant   "contained"
                                              :color     "secondary"
                                              :startIcon (r/as-element [send])
                                              :onClick   #(reset! !show-send-me true)
                                              } "An mich senden"])]
           )]
        ))))

(defn get-mail [!actual-training disabled]
  (let [!state (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !show-send-me (r/cursor !state [:show-send-me])]
    (fn []
      (let [has-edit-right false
            save-email-fn (fn [subject body] (d-trainings/>training-save (:trainingEvent-uuid @!actual-training)
                                                                         {:trainingEvent-invitationMailBody    body
                                                                          :trainingEvent-invitationMailSubject subject
                                                                          }
                                                                         (fn [data] (reset! !actual-training data))))]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du diese Veranstaltungs-Einladung Email testweise an dich senden ?" "Senden"
          (fn [] (d-trainings/>training-send-test-invitation (:trainingEvent-uuid @!actual-training) (:tom-id @!actual-user)))]
         [:div
          (if disabled
            [:div
             [:h3 "Einladungsmail Inhalt"]
             [:div "Betreff: " (get @!actual-training :trainingEvent-invitationMailSubject)]
             [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-training :trainingEvent-invitationMailBody) ""))}
                    :className               "editor-preview-widget"
                    :style                   {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]]

            [(edit-email-card/get-it
               (get @!actual-training :trainingEvent-invitationMailSubject)
               (get @!actual-training :trainingEvent-invitationMailBody)
               save-email-fn
               {:title             "Einladungsmail "
                :template-group    "training"
                :template-type     "email"
                :subText           "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#,#ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BRIEFING#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#,#BOOKING_LINK#,#BOOKING_LINK#"
                :additional-button [mui/button {
                                                :variant   "contained"
                                                :color     "secondary"
                                                :startIcon (r/as-element [send])
                                                :onClick   #(reset! !show-send-me true)
                                                } "An mich senden"]})]
            )
          ]
         ]
        ))))


(defn get-slot [slot !training-detail-loaded? disabled]
  (let [!list-loaded (r/cursor v-state/app-state [:training :trainingEvent-list-state :loaded])
        !st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !data (r/cursor !st [:data])]
    (fn []
      (let [changed? (fn [key & [as_str?]]
                       (and (exists? (get @!data key))
                            (if as_str?
                              (not= (str (get @!data key)) (str (get slot key)))
                              (not= (get @!data key) (get slot key)))))
            has-changes? (or
                           (changed? :trainingSlot-name)
                           (changed? :trainingSlot-location)
                           (changed? :trainingSlot-maxMember true)
                           (changed? :trainingSlot-timeFrom)
                           (changed? :trainingSlot-timeTo)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))]
        [mui/card
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "0"}
            }
           ;[mui/grid
           ; {:container false :item true
           ;  :md 12
           ;  :xs 12
           ;  :style {:padding "5px"}
           ;  }
           ; (str "--" slot)
           ; ]

           [mui/grid
            {:container false :item true
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :trainingSlot-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (get slot :trainingSlot-name))
                             :onChange     (fn [e] (change-fn :trainingSlot-name (h/event-value e)))
                             :label        "Name"}]
            ]
           [mui/grid
            {:container false :item true
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :trainingSlot-location) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (get slot :trainingSlot-location))
                             :onChange     (fn [e] (change-fn :trainingSlot-location (h/event-value e)))
                             :label        "Ort"}]
            ]


           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :trainingSlot-timeFrom) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Beginn"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :trainingSlot-timeFrom date)))
                             ;:error (< u-birthday 0)
                             :defaultValue    (h/from-timezone-iso (get slot :trainingSlot-timeFrom))
                             ;:helperText (if (< u-birthday 0) "Geburtsdatum ist ein Pflichtfeld" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :trainingSlot-timeTo) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :trainingSlot-timeTo date)))
                             :defaultValue    (h/from-timezone-iso (get slot :trainingSlot-timeTo))
                             }]
            ]
           [mui/grid
            {:container false :item true
             :md        3
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :trainingSlot-maxMember) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :type         "number"
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (get slot :trainingSlot-maxMember))
                             :onChange     (fn [e] (change-fn :trainingSlot-maxMember (h/event-value e)))
                             :label        "Max Teilnehmer"}]
            ]
           ]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          :onClick   #(reset! !edit-mode false)
                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (not has-changes?)
                          :onClick   (fn [] (d-trainings/>training-slot-save (:trainingSlot-uuid slot)
                                                                             @!data
                                                                             (fn []
                                                                               (reset! !training-detail-loaded? false)
                                                                               (reset! !list-loaded false))
                                                                             ))
                          } "Speichern"])
           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [delete-forever])
                          :onClick   (fn [] (d-trainings/>training-slot-save (:trainingSlot-uuid slot)
                                                                             {:trainingSlot-active false}
                                                                             (fn []
                                                                               (reset! !training-detail-loaded? false)
                                                                               (reset! !list-loaded false))
                                                                             ))
                          } "Löschen"])

           ]
          ]

         ]))))

(defn get-slots [!actual-training !training-detail-loaded? !create-modal disabled]

  (let [has-edit-right false]
    [mui/card
     [mui/card-header {:title "Veranstaltungs Termine"}]
     [mui/card-content
      (for [slot (sort-by :trainingSlot-name (filter #(not (false? (:trainingSlot-active %))) (:trainingEvent-slot @!actual-training)))]
        ^{:key (str "slot-form-" (:trainingSlotMember-uuid slot))}
        [(get-slot slot !training-detail-loaded? disabled)]
        )]
     [mui/card-actions
      (when-not disabled
        [mui/button {:startIcon (r/as-element [add])
                     :onClick   #(reset! !create-modal true)
                     }
         "Termin hinzufügen"])
      ]]

    ))



(defn get-it [!actual-training !training-detail-loaded? disabled]
  (let [!create-modal (r/cursor v-state/app-state [:training-slot-create-modal])]
    [mui/card-content {}
     [create-with-name-modal/modal
      !create-modal
      "Bitte gib einen Namen für den neuen Termin ein"
      "Erstellen"
      (fn [name] (d-trainings/>new-training-slot (:trainingEvent-uuid @!actual-training) name (fn [] (reset! !training-detail-loaded? false))))
      ]
     [(get-base !actual-training disabled)]
     [:br]
     [get-slots !actual-training !training-detail-loaded? !create-modal disabled]
     [:br]
     [(get-description !actual-training disabled)]
     [:br]
     [(get-mail !actual-training disabled)]

     ]))





































